import { Button, Flex, Row, Col } from "antd";
import MemberCard from "./MemberCard";
import { useMediaQuery } from "react-responsive";

import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { SwiperSlide, Swiper } from "swiper/react";
import { useState } from "react";
import { getStrapiMedia } from "../../../helpers/tranformers";

const OurTeam = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [swiperRef, setSwiperRef] = useState(null);

  const prevHandler = () => {
    swiperRef.slidePrev();
  };

  const nextHandler = () => {
    swiperRef.slideNext();
  };

  return (
    <div className="our-team-background">
      <div className="section-content mobile-padding-all">
        <div
          className="about-section-heading "
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-delay="100"
        >
          {content?.Heading}
        </div>

        <Row justify={"space-between"}>
          <Col lg={15} sm={24}>
            <div
              className="section-heading"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-delay="100"
            >
              {content?.Title}{" "}
            </div>
          </Col>
          {/* <Col lg={3}>
            <Button
              className="gradient-outlined-button"
              shape="rounded"
              data-aos="fade-down"
              data-aos-duration="700"
              data-aos-delay="100"
            >
              VIEW ALL MEMBERS
            </Button>
          </Col>{" "} */}
        </Row>

        {!isMobile ? (
          <div className="card-section mobile-mt-40 ">
            {content?.Card?.map((member, index) => {
              return (
                <MemberCard
                  title={member?.Name}
                  designation={member?.Designation}
                  profileImg={getStrapiMedia(member?.ProfileImage?.url)}
                  flipDelay={index + 1 + "00"}
                  linkedInUrl={member?.LinkedinUrl}
                  key={index}
                />
              );
            })}
          </div>
        ) : (
          <div>
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              centeredSlides={true}
              onSwiper={(swiper) => setSwiperRef(swiper)}
            >
              {content?.Card?.map((member, index) => {
                return (
                  <SwiperSlide key={index}>
                    <MemberCard
                      title={member?.Name}
                      designation={member?.Designation}
                      profileImg={getStrapiMedia(member?.ProfileImage?.url)}
                      flipDelay={index + 1 + "00"}
                      linkedInUrl={member?.LinkedinUrl}
                      key={index}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="swiper-controls">
              <Button
                variant="outlined"
                className="slider-button-prev"
                onClick={prevHandler}
              >
                <ArrowLeftOutlined />
              </Button>
              <Button
                variant="outlined"
                type=""
                className="slider-button-next"
                onClick={nextHandler}
              >
                <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default OurTeam;
